var _defs, _line, _line2, _rect, _circle, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew301({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8.35,
    y1: 4.02,
    x2: 3.17,
    y2: 4.02
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.76,
    y1: 6.1,
    x2: 5.76,
    y2: 1.95
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 8.7,
    y: 1.81,
    width: 3.82,
    height: 4.44,
    transform: "translate(6.59 14.64) rotate(-90)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 10.58,
    cy: 12.21,
    r: 1.84
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.58,
    y1: 5.93,
    x2: 10.58,
    y2: 11.11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew301);
export default __webpack_public_path__ + "static/media/Symbolpack_New_301.7adac8e5fbc7a90adc01ee01b25e6fde.svg";
export { ForwardRef as ReactComponent };